import React from "react";
import { connect } from "react-redux";

// Components
import Loader from "../../utils/Loader";
import ErrorText from "../../utils/error-success/ErrorText";
import SectionBanner from "../../utils/SectionBanner";
import NewsPreviewItem from "./NewsPreviewItem";

// CSS
import "../../../css/sections/sections.css";

// ===================================================================================
//  Note: getNews() will be called by parent so it can be pre-rendered on SSR
// ===================================================================================

class NewsListing extends React.PureComponent {
	renderItems = () => {
		const { news } = this.props.news;

		if (!news) return;

		return news.map((item, id) => {
			return <NewsPreviewItem key={id} item={item} />;
		});
	};

	render() {
		const { translations } = this.props;
		const { isLoading, error } = this.props.news;

		return (
			<div className="section section-2--main">
				<SectionBanner
					link={{
						href: `/news`,
						title: translations.sections.news_listing.title_bar_link
					}}
				>
					{translations.sections.news_listing.title_bar_title}
				</SectionBanner>
				<div className="section-content section-content--dark-bg">
					{isLoading ? (
						<Loader />
					) : error ? (
						<ErrorText errors={error} />
					) : (
						this.renderItems()
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations,
		news: state.news
	};
};

export default connect(
	mapStateToProps,
	null
)(NewsListing);



// WEBPACK FOOTER //
// ./src/components/home/news/NewsListing.js